
























































import { Component, Prop, Mixins, Inject, Watch } from 'vue-property-decorator';
import VueScrollTo from 'vue-scrollto';
import { MainHeader, Button, Errors } from '@/pages/profile/components';
import {
  Footer,
  Header,
  ExpiredCert,
  WithoutCert,
  CertData,
  CertScore,
  Statement,
  StatementBtn,
  Sucsess,
} from './components';
import store from '@/pages/profile/store';
import generatePdf, { getBase64Image } from '@/tools/generatepdf';
import { pfdodService, statementService } from '@/services';
import { LoaderMixin } from '@/pages/profile/mixins';
import { ACTIONS } from '@/store/user';
import isArrayNotEmpty from '@/tools/isarraynotempty';
import { issue, nominal } from './utils';
import {
  ICertificate,
  StatusEnum,
  CertificateType,
  PfdodCert,
  AxiosInstance,
  AxiosResponse,
  ChildData,
  StatementEnum,
} from './types';
import {
  ERROR_MESSAGE,
  STATEMENT_MESSAGE,
  NOMINAL_MESSAGE,
  STATEMENT_BTN_TEXT,
  NOMINAL_BTN_TEXT,
} from './const';

@Component({
  components: {
    Errors,
    Footer,
    Header,
    Sucsess,
    CertData,
    CertScore,
    Statement,
    MainHeader,
    ExpiredCert,
    WithoutCert,
    StatementBtn,
  },
  metaInfo: () => ({
    title: 'Управление сертификатами',
  }),
})
export default class Certificate
  extends Mixins(LoaderMixin)
  implements ICertificate {
  @Inject()
  readonly $api!: AxiosInstance;

  @Inject()
  readonly $config!: any;

  errors: Array<any> = [];
  currentChild: any = {};
  error: boolean = false;
  isStatment: boolean = false;
  statementText: string = '';
  infoMessage: string = '';
  sucsessBtnText: string = STATEMENT_BTN_TEXT;

  get id(): string {
    return store.state.id;
  }

  get state(): any {
    return this.$store.state;
  }

  get userProfile() {
    const { user } = this.state;
    return user && user.profile;
  }

  get userName(): string {
    const { userProfile } = this;
    return userProfile ? userProfile.fio : '';
  }

  get municipalityName() {
    const { userProfile } = this;
    return userProfile ? userProfile.municipality_name : '';
  }

  get userPhone(): string {
    const { userProfile } = this;
    return userProfile ? userProfile.phone : '';
  }

  get userEmail(): string {
    const { userProfile } = this;
    return userProfile ? userProfile.email : '';
  }

  get orgName(): string {
    const { regionProfile } = this.state;
    return regionProfile && regionProfile.orgName ? regionProfile.orgName : '';
  }

  get logoImg(): string {
    const { logoImage } = this.state.regionProfile;
    return !!logoImage ? logoImage : '';
  }

  get isSertificateConfirmed(): boolean {
    const { certificateType } = this.currentChild;
    return certificateType === 'undefined';
  }

  @Watch('id', { immediate: true })
  onChangeChild(id: string): void {
    this.parseChildren(id);
    this.errors = [];
    this.isStatment = false;
  }

  beforeUpdate() {
    if (Object.keys(this.currentChild).length) {
      const {
        orgName,
        userName,
        userPhone,
        userEmail,
        municipalityName,
        currentChild: {
          fio,
          birthday,
          isUndefinedType,
          isAccountType,
          certificateNumber,
        },
      } = this;

      if (isUndefinedType) {
        this.statementText = issue(
          userName,
          municipalityName,
          fio,
          birthday,
          userPhone,
          userEmail,
          orgName
        );
      }

      if (isAccountType) {
        this.statementText = nominal(
          userName,
          userPhone,
          userEmail,
          fio,
          birthday,
          certificateNumber
        );
      }
    }
  }

  beforeDestroy(): void {
    this.currentChild = {};
  }

  parseChildren(id: string): void {
    if (id && id.length) {
      const { user } = this.state;
      const child =
        user &&
        user.children &&
        user.children.find(({ id }: { id: string }) => this.id === id);
      if (child) {
        this.currentChild = pfdodService.parser(child);
        this.status = StatusEnum.SUCCESS;
      }
    }
  }

  action(childAction: string): void {
    (this as any)[childAction]();
  }

  actionMakePdf(): void {
    const { $api, currentChild, logoImg } = this;

    if (!currentChild.id) {
      return;
    }

    const {
      certificateNumber,
      firstName,
      patroName,
      lastName,
      birthday,
      certificateDateStart,
      certificateDateEnd,
      certificateAmountTotal,
      municipalityName,
    } = currentChild;

    const result = {
      cert: certificateNumber,
      name: [firstName, patroName]
        .map((item) => item.trim())
        .filter((item) => !!item)
        .join(' '),
      lastname: lastName,
      birthday,
      from: certificateDateStart,
      to: certificateDateEnd,
      nominal: certificateAmountTotal,
      municipality: municipalityName,
      link: window.location.origin,
      logo: '',
    };

    const img = new Image();
    img.src = logoImg;
    img.onload = () => {
      try {
        const base64 = getBase64Image(img);
        result.logo = base64;
      } catch (e) {
        // Тут можно вывести ошибку
      }
      generatePdf(result);
    };
  }

  actionActivateCert(): void {
    const { $router, currentChild } = this;
    const routeData = $router.resolve(currentChild!.toIssue);
    window.open(routeData.href, '_blank');
  }

  async actionGetNominal(): Promise<void> {
    const {
      $api,
      currentChild: { certificateId, id },
    } = this;
    if (!certificateId) return;
    this.setStatus('loading');
    try {
      const { success, errors } = await statementService(
        $api
      ).postStatementAllowed(
        { data: { subject_id: certificateId } },
        'ValueCert'
      );

      if (success) {
        this.isStatment = false;

        await statementService($api).postStatementCreate(
          { data: { subject_id: certificateId } },
          'ValueCert'
        );

        this.$store.dispatch(`user/${ACTIONS.GET_CHILDREN}`).finally(() => {
          this.parseChildren(id);
          this.infoMessage = NOMINAL_MESSAGE;
          this.setStatus('success');
        });
      }

      if (!success && isArrayNotEmpty(errors)) {
        const [errorText] = errors;
        const { msg } = errorText;
        if (msg && msg.length) this.errors.push(msg);
        this.setStatus('success');
      }
    } catch (error) {
      this.setStatus('error');
      const { errors, err_code, message } = error.response.data;
      if (errors && err_code === 400) {
        this.errors.push(errors[0].msg);
      } else {
        this.errors.push(ERROR_MESSAGE);
      }
    }
    this.scrollToTop();
  }

  async actionGetCert(): Promise<void> {
    const { currentChild, $api } = this;
    const { id } = currentChild;
    if (!id) return;
    const data: PfdodCert = { kid_id: id };
    this.setStatus('loading');
    try {
      await $api.post<AxiosResponse<any>>('pfdod/certificate/generate', {
        data,
      });
      this.$store.dispatch('user/children').finally(() => {
        this.parseChildren(id);
        this.setStatus('success');
      });
    } catch (error) {
      this.setStatus('error');
      const { errors, err_code, message } = error.response.data;
      if (errors && err_code === 400) {
        this.errors.push(errors[0].msg);
      } else {
        this.errors.push(ERROR_MESSAGE);
      }
    }
  }

  toggleStatement() {
    this.isStatment = !this.isStatment;
  }

  btnClickHendler(value: string) {
    const { isUndefinedType, isAccountType } = this.currentChild;
    if (StatementEnum.STATEMENT === value && isUndefinedType)
      this.actionStatementCert();
    if (StatementEnum.STATEMENT === value && isAccountType)
      this.actionGetNominal();
    if (StatementEnum.CLOSE === value) this.toggleStatement();
  }

  sucsessHendler() {
    const { isAccountType, isFinanceType } = this.currentChild;
    this.infoMessage = '';
    if (isAccountType) this.sucsessBtnText = NOMINAL_BTN_TEXT;
    if (isFinanceType) this.$router.push({ name: 'events' });
  }

  async actionStatementCert() {
    const {
      currentChild: { id },
      $api,
    } = this;

    if (!id) return;
    this.setStatus('loading');
    try {
      const { success, errors } = await statementService(
        $api
      ).postStatementAllowed({ data: { subject_id: id } }, 'PfdodKid');

      if (success) {
        this.isStatment = false;

        await statementService($api).postStatementCreate(
          { data: { subject_id: id } },
          'PfdodKid'
        );

        this.$store.dispatch(`user/${ACTIONS.GET_CHILDREN}`).finally(() => {
          this.parseChildren(id);
          this.infoMessage = STATEMENT_MESSAGE;
          this.setStatus('success');
        });
      }

      if (!success && isArrayNotEmpty(errors)) {
        const [errorText] = errors;
        const { msg } = errorText;
        if (msg && msg.length) this.errors.push(msg);
        this.setStatus('success');
      }
    } catch (error) {
      this.setStatus('error');
      const { errors, err_code, message } = error.response.data;
      if (errors && err_code === 400) {
        this.errors.push(errors[0].msg);
      } else {
        this.errors.push(ERROR_MESSAGE);
      }
    }
    this.scrollToTop();
  }

  scrollToTop() {
    VueScrollTo.scrollTo('body', 500, {
      easing: 'ease-in-out',
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/certificate/Certificate.vue